import { useCallback } from 'react'

import dayjs from 'dayjs'

const DEFAULT_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

type Time = number | string | Date

export const useTimeFormatter = (format: string = DEFAULT_TIME_FORMAT) => {
  return useCallback(
    (time: Time) => {
      if (!time) return '-'
      let t = time
      if (typeof t === 'string' && /^\d+$/.test(t)) {
        t = Number(t)
      }
      if (typeof t === 'number' && t < 1e12) {
        t = t * 1000
      }
      return dayjs(t).format(format)
    },
    [format]
  )
}

export const getBrowserUtcOffsetHours = () =>
  -new Date().getTimezoneOffset() / 60

export const formatUtcOffsetLabel = (hours: number) => {
  const sign = hours >= 0 ? '+' : '-'
  const abs = Math.abs(hours)
  const hh = Math.floor(abs)
  const mm = Math.round((abs - hh) * 60)
  const hhStr = String(hh).padStart(2, '0')
  const mmStr = String(mm).padStart(2, '0')
  return `${sign}${hhStr}:${mmStr}`
}
